import gql from 'graphql-tag';

import { useMutation } from '@apollo/client';
import { VENDOR_BRANCH_FIELDS } from '../../fragments/bender/vendorBranch';
import {
  UpdateVendorBranch,
  UpdateVendorBranchVariables,
} from '../../athena/types/UpdateVendorBranch';

export const UPDATE_VENDOR_BRANCH = gql`
  mutation UpdateVendorBranch($id: String, $name: String, $organizationId: String) {
    vendor {
      updateVendorBranch(
        input: { vendorBranch: { id: $id, name: $name, organizationId: $organizationId } }
      ) {
        vendorBranch {
          ...VendorFields
        }
      }
    }
  }
  ${VENDOR_BRANCH_FIELDS}
`;

export const useUpdateVendorBranch = () => {
  return useMutation<UpdateVendorBranch, UpdateVendorBranchVariables>(UPDATE_VENDOR_BRANCH);
};
